import DimensiHeadNew from "../../../../../components/categories/siakad/laporan_adab/penilaian/HomeHead-New";
export default function Home() {
  
  return (
    <DimensiHeadNew />
  );
}
